import { createRouteRef } from '@backstage/frontend-plugin-api';

/**
 * Raiz do plugin. O routeRef fica num arquivo próprio para não criar ciclo de
 * import entre o registro do plugin e o roteador interno, que também precisa
 * dele.
 */
export const rotaRaiz = createRouteRef();
